import { connect } from "react-redux";
import close_icon from "../../../../assets/icons/close.svg";
import Formulario from "../../../components/Formulario";
import { mapDispatchToProps, mapStateToProps } from "../../../../utils/config";
import { useEffect, useState } from "react";
import { municipiosDoEstado, acharMunicipio } from "../../../../utils/municipios";
import ControllerCadastro from "../../auth/Cadastro/controller";
import ControllerConfiguracoes from "../Home/controller";
import Loading from "../../../components/Loading";
import AlertDialog from "../../../components/AlertDialog";

function AlterarCidadeModal({usuario, setUsuario, errors, setErrors, onClose}){
  const [loading, setLoading] = useState(false);
  const [dadosUsuario, setDadosUsuario] = useState({...usuario});
  const [showSuccess, setShowSuccess] = useState(false);
  // Cidades do estado do usuario (IBGE). null = ainda carregando ou indisponivel: o
  // campo continua livre e o servidor segue aceitando o texto.
  const [municipios, setMunicipios] = useState(null);
  const [erroCidade, setErroCidade] = useState("");

  useEffect(() => {
    let vivo = true;
    municipiosDoEstado(usuario.estado).then((l) => { if (vivo) setMunicipios(l); });
    return () => { vivo = false; };
  }, [usuario.estado]);

  function salvar(e) {
    if (municipios) {
      const oficial = acharMunicipio(municipios, dadosUsuario.cidade);
      if (!oficial) {
        setErroCidade(`Escolha uma cidade de ${usuario.estado} na lista.`);
        return;
      }
      // grafia oficial (acentos e maiusculas) antes de enviar
      dadosUsuario.cidade = oficial;
    }
    setErroCidade("");
    controllerConfiguracoes.alterarDados(e, 'form-alterar-cidade', dadosUsuario, setShowSuccess);
  }

  const controllerCadastro = new ControllerCadastro(dadosUsuario, errors, setDadosUsuario, setErrors, null);
  const controllerConfiguracoes = new ControllerConfiguracoes(usuario, errors, setErrors, setLoading, setUsuario);

  return(
    <div className="modal">
      {loading && <Loading/>}
      {showSuccess && (
        <AlertDialog
          titulo={`Cidade alterada com sucesso!`}
          buttonText={"Ver meus dados"}
          buttonOnClick={onClose}
        />
      )}
      <div className="content-modal">
        <div className="top">
          <h3>Alterar Cidade</h3>
          <button type="button" onClick={onClose}>
            <img src={close_icon} alt="Icone de fechar"/>
          </button>
        </div>

        <Formulario id="form-alterar-cidade">
          
          <div className="form-group">
            <label htmlFor="cidade">Cidade</label>
            <input type="text" id="cidade" name="cidade" list="cidades-do-estado" placeholder={`Cidade de ${usuario.estado || "seu estado"}`} required autoComplete="off"
              value={dadosUsuario.cidade} onChange={(e)=>{ setErroCidade(""); controllerCadastro.validarCidade(e); }} className={(errors.cidade || erroCidade) && 'input-error'}
            />
            {municipios && <datalist id="cidades-do-estado">{municipios.map((m) => <option key={m} value={m} />)}</datalist>}
            <span className="error">{erroCidade || errors.cidade}</span>
          </div>

          <div className="form-group">
          <button type="button" onClick={salvar}>Salvar</button> 
          </div>


              
        </Formulario>
      </div>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(AlterarCidadeModal);